import _defineProperty from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/createClass.js";
var Data = Symbol('data');
var id_counter = 0;
export function id(prefix) {
  return (prefix || '') + ++id_counter;
}
export var BaseObject = /*#__PURE__*/function () {
  function BaseObject() {
    _classCallCheck(this, BaseObject);
  }

  _createClass(BaseObject, [{
    key: "toObject",
    value: function toObject() {
      return _toObject(this);
    }
  }]);

  return BaseObject;
}();
export function assign(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (sources.length === 1 && Array.isArray(sources[0])) {
    target[Data] = sources[0];
  } else {
    sources.forEach(function (s) {
      Object.assign(target[Data], isObject(s) && s[Data] || s);
    });
  }

  return target;
}
export function flat(value) {
  var _ref;

  return Array.isArray(value) ? (_ref = []).concat.apply(_ref, _toConsumableArray(value)) : value;
}
export function get(obj, name) {
  return obj[Data][name];
}
export function set(obj, name, value) {
  obj[Data][name] = object(value);
}
export function copy(obj) {
  var mod = Object.create(Object.getPrototypeOf(obj));
  Object.assign(mod, obj);
  mod[Data] = Object.assign({}, obj[Data]);
  return mod;
}
export function init(obj, value) {
  obj[Data] = value || {};
}

function recurse(d, flag) {
  //console.log('RECURSE', d);
  return d && d.toObject ? d.toObject(flag) : _toObject(d);
}

function _toObject(value) {
  if (isArray(value)) {
    return value.map(function (d) {
      return recurse(d);
    });
  } else if (isObject(value)) {
    var data = value[Data] || value;
    return isArray(data) ? recurse(data) : Object.keys(data).reduce(function (_, k) {
      _[k] = recurse(data[k]);
      return _;
    }, {});
  } else {
    return value;
  }
}

export function raw(value) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, Data, value), _defineProperty(_ref2, "toObject", function toObject() {
    return value;
  }), _ref2;
}

function object(value) {
  return isObject(value) && !value[Data] ? _defineProperty({}, Data, value || {}) : value;
}

export function merge(flag) {
  var _ref4;

  for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    values[_key2 - 1] = arguments[_key2];
  }

  var objects = (_ref4 = []).concat.apply(_ref4, values).map(function (_) {
    return recurse(_, flag);
  });

  return object(Object.assign.apply(Object, [{}].concat(_toConsumableArray(objects))));
}
export function nest(obj, keys, rest) {
  var m = keys.reduce(function (m, k) {
    return m[k] = 1, m;
  }, {}),
      u = {},
      v = {};

  for (var k in obj) {
    (m[k] ? u : v)[k] = obj[k];
  }

  u[rest] = v;
  return u;
} // -- type checkers --

export var isArray = Array.isArray;
export function isBoolean(_) {
  return typeof _ === 'boolean';
}
export function isIterable(_) {
  return isObject(_) && typeof _[Symbol.iterator] === 'function';
}
export function isNumber(_) {
  return typeof _ === 'number';
}
export function isObject(_) {
  return _ === Object(_) && !isArray(_);
}
export function isString(_) {
  return typeof _ === 'string';
}